import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  createSelector,
} from '@reduxjs/toolkit'

import { Tutorial } from '@/models/tutorial'
import api from '@/shared/api'
import { ENDPOINTS } from '@/shared/constants'
import { RootState } from '@/store'
import { toast } from 'react-toastify'

interface TutorialsState {
  tutorials: Tutorial[]
  loading: boolean
  error: string | null
}

// Estado inicial
const initialState: TutorialsState = {
  tutorials: [],
  loading: false,
  error: null,
}

// Função para buscar itens da API
export const fetchTutorials = createAsyncThunk<Tutorial[]>(
  'tutorials/fetchTutorials',
  async (_, thunkAPI) => {
    try {
      const response = await api.get(ENDPOINTS.TUTORIALS.GET.ALL)

      return (await response.data) as Tutorial[]
    } catch (error: unknown) {
      toast.error('Erro ao listar tutoriais')
      let errorMessage = 'Unknown error'

      if (error instanceof Error) {
        errorMessage = error.message
      }

      return thunkAPI.rejectWithValue(errorMessage)
    }
  }
)

// Slice
const tutorialsSlice = createSlice({
  name: 'tutorials',
  initialState,
  reducers: {
    // Exemplo de reducer adicional, se necessário
    clearError(state) {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTutorials.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchTutorials.fulfilled,
        (state, action: PayloadAction<Tutorial[]>) => {
          state.loading = false
          state.tutorials = action.payload
        }
      )
      .addCase(fetchTutorials.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

// Exporta ações e reducer
export const { clearError } = tutorialsSlice.actions
export default tutorialsSlice.reducer

export { tutorialRouteOptions as routeOptions } from '@/shared/tutorialRoutes'

// Selector
export const routesWithTutorialSelector = createSelector(
  (state: RootState) => state.tutorials.tutorials,
  (tutorials) => tutorials.map((tutorial) => tutorial.route)
)
